module.exports = __webpack_public_path__ + "img/asus-k513.f3a09b71.jpg";